import { useSupportChat } from '../chat/hooks';
import type { SupportFormDiagnostics } from './types';

export interface SendingDomainSupport {
  /** `null` when the disabled domain is unknown: the form still opens, with no domain attached. */
  askAboutDisabledDomain: (domain: string | null) => void;
  requestIpPoolChange: (domain: string, requestedPoolTitle: string) => void;
}

function domainDiagnostics(lines: string[]): SupportFormDiagnostics {
  return { label: 'Sending domain', summary: lines.join('\n') };
}

/** Opens the support form for a sending domain, with the domain attached to the ticket. */
export function useSendingDomainSupport(): SendingDomainSupport {
  const { openForm } = useSupportChat();

  return {
    askAboutDisabledDomain: (domain) => {
      openForm(undefined, 'sending_domain_disabled', {
        kind: 'sending_domain_disabled',
        diagnostics: domain == null ? undefined : domainDiagnostics([`Domain: ${domain}`]),
      });
    },
    requestIpPoolChange: (domain, requestedPoolTitle) => {
      openForm(undefined, 'ip_pool_request_pending', {
        kind: 'ip_pool_request_change',
        diagnostics: domainDiagnostics([`Domain: ${domain}`, `Requested IP pool: ${requestedPoolTitle}`]),
      });
    },
  };
}
